export default {
  UNCHECKED: 'UNCHECKED',
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE'
}
